import React from "react";

const EmptyState = ({ 
  icon = "📦", 
  title = "No Data Found", 
  description = "There's nothing to show here yet.", 
  actionText = "Get Started",
  onAction,
  showAction = true 
}) => {
  return (
    <div className="text-center py-12 px-4">
      <div className="text-6xl mb-4">{icon}</div>
      <h3 className="text-xl font-bold text-gray-700 mb-2">{title}</h3>
      <p className="text-gray-500 mb-6 max-w-md mx-auto">{description}</p>
      {showAction && onAction && (
        <button
          onClick={onAction}
          className="bg-green-600 text-white px-6 py-3 rounded-full font-medium hover:bg-green-700 transition-all duration-200 shadow-lg"
        >
          {actionText}
        </button>
      )}
    </div>
  );
};

export default EmptyState; 